import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InputTitleCaseDirective } from './input-title-case/input-title-case.directive';
import { AutocapitalizeallDirective } from './autocapitalizeall.directive';
import { AppTwoDigitDecimaNumberDirective } from './app-two-digit-decima-number.directive';
import { TrimDirective } from './app-trim.directive';


@NgModule({
  declarations: [InputTitleCaseDirective, AutocapitalizeallDirective,  AppTwoDigitDecimaNumberDirective, TrimDirective],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports:[InputTitleCaseDirective, AutocapitalizeallDirective, AppTwoDigitDecimaNumberDirective, TrimDirective]
})
export class CustomDirectiveModule { }
